import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import Help from "../constant/help";

const TypingEffectMarkdown = ({ text, speed = 10, isStreaming = true }) => {
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    if (!isStreaming) {
      setDisplayed(text);
      return;
    }

    const interval = setInterval(() => {
      setDisplayed((prev) => {
        if (prev.length >= text.length) {
          clearInterval(interval);
          return prev;
        }
        return text.slice(0, prev.length + 1);
      });
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, isStreaming]);

  return (
    <ReactMarkdown
      components={{
        a: ({node, ...props}) => (
          <a
            {...props}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          />
        )
      }}
    >
      {Help.formatMessage(displayed)}
    </ReactMarkdown>
  );
};

export default TypingEffectMarkdown;
